import type { RecipientRole } from '../api'

/**
 * The six recipient tones, the one definition of them. One colour per
 * recipient, so a box on the page and a row in the list are plainly the same
 * person: the sending page, the workflow canvas and its preview all read
 * this, and the phone app's recipientTones are held to it by `make brand`
 * (scripts/brand_mobile/tokens.py reads this constant). They were written out
 * three times, and three copies can drift.
 *
 * Each carries a white uppercase label at 10.88px, so each has to clear 4.5:1
 * against white. Two did not: the orange was 4.01:1 and the teal 4.24:1, and
 * the orange is the SECOND signer, which is the most common one there is.
 * They were darkened 8% and 5%; nothing else moved. They are not tokens
 * because the PDF canvas is white whatever the interface is doing, so they
 * cannot follow the material's ruling.
 */
export const WORKFLOW_TONES = ['#1f4fd8', '#b25e09', '#0e8377', '#7a4ad1', '#0d7a94', '#c2325f']

export type WorkflowParticipantRole = Extract<RecipientRole, 'signer' | 'witness' | 'cc' | 'needs_to_view'>

export type WorkflowParticipant = {
  id: string
  name: string
  email: string
  role: WorkflowParticipantRole
  tone: number
  group?: string
}

export type WorkflowStage =
  | { id: string; kind: 'solo'; title: string; participantId: string }
  | { id: string; kind: 'chain'; title: string; detail?: string; participantIds: string[] }
  | { id: string; kind: 'group'; title: string; detail: string; groupLabel: string; participantIds: string[] }
  | {
      id: string
      kind: 'branch'
      title: string
      detail: string
      branchId: string
      afterParticipantId: string
      targetParticipantId: string
      field: string
      value: string
    }
  | { id: string; kind: 'notify'; title: string; participantIds: string[] }

export type WorkflowDraft = {
  document: string
  activeId?: string
  participants: WorkflowParticipant[]
  stages: WorkflowStage[]
}

export type InsertKind = 'signer' | 'branch' | 'group' | 'notify'

export type WorkflowOrder = 'parallel' | 'sequential'

export type WorkflowApplyResult = {
  order: WorkflowOrder
  routingEnabled: boolean
  routingThreshold: string
  routingFieldLabel: string
}
